import React, { Component } from 'react';
import DataTable from "react-data-table-component";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { tokenVerification } from './Utils';

class Avatar extends Component {
    constructor() {
        super();
        this.state = {
            dataStartedProcessing: false,
            showLoader: false,
            data: [],
            editedName: "",
            editedEthnicity: "",
            editedAvatarGender: "",
            editedAccountId: "",
            editedSceneId: "",
            editedVersionId: "",
            disabled: false,
            editedId: "-1",
            pageNum: null,
            paginationValue: 10,
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            ethnicityData: [],
            avatarGenderData: [],
            searchTerm: "",
            noMatchingData: false,
            isLoading: true
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
    }
    componentDidMount() {
        var thisController = this;

        thisController.fetchEthnicity();
        thisController.fetchAvatarGender();
        thisController.fetchAvatarDetails();

        if (this.props.location.state != undefined) {
            this.setState({ pageNum: this.props.location.state.pageNum });
        }

    }
    addNewAvatarRow = () => {
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        this.state.data.unshift({
            id: '',
            name: '',
            ethnicity: '',
            accountId: '',
            sceneId: '',
            versionId: '',
        });
        this.setState({
            data: this.state.data,
            noMatchingData: false,
            disabled: true,
            editedId: "",
        })
    }

    makeCelledit(row, e) {
        this.markAsBeingEdited(row.id);
        this.state.editedName = row.name;
        this.state.editedEthnicity = row.ethnicity;
        this.state.editedAvatarGender = row.avatarGender;
        this.state.editedAccountId = row.accountId;
        this.state.editedSceneId = row.sceneId;
        this.state.editedVersionId = row.versionId;
        this.setState(this.state);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    fetchAvatarDetails = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/load-avatars",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    var messages = res.result;
                    thisController.state.disabled = false;
                    thisController.state.noMatchingData = false;
                    thisController.state.isLoading = false;
                    thisController.state.showLoader = true;
                    thisController.state.data = messages;
                    thisController.data = messages;
                    thisController.setState(thisController.state);
                } else {
                    // thisController.notifyError(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        });
    }

    fetchEthnicity = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/load-ethinicity",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),

            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.ethnicityData = res.result;
                    thisController.state.noMatchingData = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        })
    }

    fetchAvatarGender = () => {
        var thisController = this;
        $.ajax({
            url: "/my-jeeva-api/load-avatar-gender",
            method: 'GET',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),

            },
            success: function (res) {
                if (res.success === true) {
                    thisController.state.avatarGenderData = res.result;
                    thisController.state.noMatchingData = false;
                    thisController.setState(thisController.state);
                } else {
                    thisController.notifyFailedResponse(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    tokenVerification();
                }
            }
        })
    }
    saveAvatarDetails(row, e) {

        var thisController = this;

        var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

        row.name = document.getElementById("name" + row.id).innerText.trim();
        row.accountId = document.getElementById("accountId" + row.id).innerText.trim();
        row.sceneId = document.getElementById("sceneId" + row.id).innerText.trim();
        row.versionId = document.getElementById("versionId" + row.id).innerText.trim()


        var avatarName = row.name;
        var ethnicity = row.ethnicity;
        var avatarGender = row.avatarGender;
        var accountId = row.accountId;
        var sceneId = row.sceneId;
        var versionId = row.versionId;
        if (avatarName == "" || ethnicity == "" || avatarGender == "" || accountId == "" || sceneId == "" || versionId == "") {
            thisController.notifyMsgFieldEmpty();
            thisController.setState({ dataStartedProcessing: false });

        }
        else if (!namePattern.test(avatarName)) {
            thisController.notifyImproperName();
        }
        else {
            thisController.state.editedId = "-1";
            thisController.state.dataStartedProcessing = true;
            thisController.setState(thisController.state);
            var saveData = {
                name: row.name,
                ethnicity: row.ethnicity,
                avatarGender: row.avatarGender,
                accountId: row.accountId,
                sceneId: row.sceneId,
                versionId: row.versionId
            }

            var timer = setInterval(function () {
                clearTimeout(timer);

                $.ajax({
                    url: "/my-jeeva-api/add-avatar",
                    method: 'POST',
                    headers: {
                        'Authorization': "Bearer " + localStorage.getItem("access_token"),
                        'Content-Type': "application/json",

                    },
                    data: JSON.stringify(saveData),
                    success: function (res) {
                        if (res.success === true) {
                            thisController.state.dataStartedProcessing = false;
                            thisController.notifyAvatarAdded();
                            thisController.fetchAvatarDetails();
                            thisController.setState({ disabled: false, dataStartedProcessing: false });
                        } else {
                            thisController.notifyFailedResponse(res.result);
                            thisController.setState({ dataStartedProcessing: false });
                        }
                    },
                    error: function (xhr) {
                        if (xhr.status == 401) {
                            window.location.href = "";
                        }
                    }
                })

            }, 2000);
        }
    }
    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There are no avatar present. </p>
        </div>
    );

    updateAvatarDetails(row, e) {
        row.name = document.getElementById("name" + row.id).innerText.trim();
        row.accountId = document.getElementById("accountId" + row.id).innerText.trim();
        row.sceneId = document.getElementById("sceneId" + row.id).innerText.trim();
        row.versionId = document.getElementById("versionId" + row.id).innerText.trim();
        var thisController = this;

        var namePattern = new RegExp(/^([a-zA-Z\s-])*$/);

        var avatarName = thisController.state.editedName;
        var ethnicity = row.ethnicity;
        var avatarGender = row.avatarGender;
        var accountId = thisController.state.editedAccountId;
        var sceneId = thisController.state.editedSceneId;
        var versionId = thisController.state.editedVersionId;

        if (avatarName == "" || ethnicity == "" || avatarGender == "" || accountId == "" || sceneId == "" || versionId == "") {
            thisController.notifyMsgFieldEmpty();
            thisController.setState({ dataStartedProcessing: false });

        }
        else if (!namePattern.test(avatarName)) {
            thisController.notifyImproperName();
        }
        else {
            var updatedData = {
                id: row.id,
                name: avatarName,
                ethnicity: ethnicity,
                avatarGender: avatarGender,
                accountId: accountId,
                sceneId: sceneId,
                versionId: versionId
            };
            $.ajax({
                url: "/my-jeeva-api/update-avatar",
                method: 'PATCH',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': 'application/json',
                },
                data: JSON.stringify(updatedData),
                contentType: "application/json; charset=UTF-8",
                success: function (res) {
                    if (res.success === true) {
                        thisController.state.editedId = "-1";
                        thisController.notifyAvatarUpdate();
                        thisController.fetchAvatarDetails();
                    } else {
                        thisController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }


            })
        }

    }
    openDeletePopUp = (row) => {

        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${row.name} ? `,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.callDeleteAvatarApi(row.id)
                },
                {
                    label: 'No',
                }
            ]
        });
    }

    callDeleteAvatarApi = (id) => {
        let avatarData = this.state.data;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            avatarData.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-avatar/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteConstructorVariables.notifyDelete();
                        avatarData.splice(id, 1);
                        deleteApiViewController.refreshData();
                    } else {
                        // avatarData.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            this.state.data.splice(id, 1);
        }
        deleteConstructorVariables.fetchAvatarDetails();


    }
    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }

    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    notifyDataProcessing() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/warn.svg"
                    style={{ paddingRight: "0px", height: "20px", width: "20px" }}
                    content=""
                />
                &nbsp;&nbsp;Hold on.Your data is saving...
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyAvatarAdded() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Avatar Details added successfully
            </b>,
            {
                position: "top-center",
            }
        );
    }
    notifyAvatarUpdate() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                &nbsp;&nbsp;Avatar Details updated successfully
            </b>,
            {
                position: "top-center",
            }
        );
    }

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }

    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Avatar Detail deleted successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        });

    }
    refreshData = (id) => {
        console.log("Resetting the data");
        this.state.data = [];
        this.state.isLoading = true;
        this.state.noMatchingData = false;
        this.state.editedId = "-1";
        this.state.disabled = false;
        this.state.searchTerm = "";
        this.setState(this.state);
        this.fetchAvatarDetails();
    }

    handleNameChange = (e) => {
        this.state.editedName = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handleAccountIdChange = (e) => {
        this.state.editedAccountId = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handleSceneIdChange = (e) => {
        this.state.editedSceneId = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    handleVersionIdChange = (e) => {
        this.state.editedVersionId = e.currentTarget.textContent.trim();
        this.setState(this.state);
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }

    onChangeOfEthnicity = (row, e) => {
        var updatedData = this.state.data.map((record) => {
            if (record.id === row.id) {
                record.ethnicity = e.target.value
            }
            return record;
        });
        this.setState({
            data: updatedData
        })
        console.log("Selected Ethnicity: " + e.target.value);
    };

    onChangeOfAvatarGender = (row, e) => {
        var updatedData = this.state.data.map((record) => {
            if (record.id === row.id) {
                record.avatarGender = e.target.value
            }
            return record;
        });
        this.setState({
            data: updatedData
        })
        console.log("Selected Gender: " + e.target.value);
    };

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a;
        var b;
        if (field === "accountId" || field === "sceneId") {
            a = rowA[field] ? rowA[field] : ""
            b = rowB[field] ? rowB[field] : ""
        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }

        if (a > b) {
            return 1;
        }
        if (b > a) {
            return -1;
        }
        return 0;
    };

    handleSearch = (event) => {
        var thisController = this;
        thisController.state.searchTerm = event.target.value;
        thisController.state.isLoading = true;
        thisController.state.data = [];
        thisController.setState(thisController.state);

        $.ajax({
            url: "/my-jeeva-api/search-avatars-data",
            method: "GET",
            data: {
                searchTerm: thisController.state.searchTerm
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },

            success: function (res) {
                if (res.success === true) {
                    if (res.result.length > 0) {
                        thisController.state.data = [];
                        thisController.state.noMatchingData = false;
                        thisController.state.isLoading = false;
                        thisController.setState(thisController.state);
                        thisController.state.data = res.result;
                        thisController.setState(thisController.state);
                    } else {
                        thisController.state.noMatchingData = true;
                        thisController.setState(thisController.state);
                    }
                }
            },
            error: function (xhr) {

            },
        });
    };

    clearSearchData = () => {
        var thisController = this;
        thisController.setState({ searchTerm: "" }, () => {
            thisController.fetchEthnicity();
            thisController.fetchAvatarGender();
            thisController.fetchAvatarDetails();
        });
    }

    render() {
        const { data } = this.state;
        var avatarController = this;

        const columns = [
            {
                name: <b style={{ fontSize: "16px" }}> Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('name'),
                // width: "19vw",
                selector: (row) => (
                    <div name="name">
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                fontSize: "15px",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleNameChange(e, row);
                            }}
                            id={"name" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.name}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Ethnicity</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('ethnicity'),
                selector: (row) => {
                    const isEditing = row.id === this.state.editedId;
                    const element = isEditing ? (
                        <select
                            className="input-group form-control select2 "
                            onChange={(e) => this.onChangeOfEthnicity(row, e)}
                            value={row.ethnicity}
                            id={"ethnicity" + row.id}
                            style={{
                                marginLeft: "0vw",
                                padding: "0px",
                                paddingTop: "5px",
                                paddingLeft: "5px",
                                background: "white",
                                border: "1px solid #D2D4DC",
                                borderRadius: "2px",
                            }}
                        >
                            <option>Choose Ethnicity</option>
                            {this.state.ethnicityData.map((ethnicityName) => (
                                <option value={ethnicityName}>
                                    {ethnicityName}
                                </option>
                            ))}

                        </select>
                    ) : (
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border: "none",
                                overflow: "hidden",
                            }}
                        >
                            {row.ethnicity}
                        </div>
                    );
                    return (
                        <div className="container-fluid" style={{ textAlign: "left" }}>
                            {element}
                        </div>
                    );
                },
            },
            {
                name: <b style={{ fontSize: "16px" }}>Gender</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('avatarGender'),
                selector: (row) => {
                    const isEditing = row.id === this.state.editedId;
                    const element = isEditing ? (
                        <select
                            className="input-group form-control select2 "
                            onChange={(e) => this.onChangeOfAvatarGender(row, e)}
                            value={row.avatarGender}
                            id={"avatarGender" + row.id}
                            style={{
                                marginLeft: "0vw",
                                padding: "0px",
                                paddingTop: "5px",
                                paddingLeft: "5px",
                                background: "white",
                                border: "1px solid #D2D4DC",
                                borderRadius: "2px",
                            }}
                        >
                            <option>Choose Gender</option>
                            {this.state.avatarGenderData.map((gender) => (
                                <option value={gender}>
                                    {gender}
                                </option>
                            ))}

                        </select>
                    ) : (
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border: "none",
                                overflow: "hidden",
                            }}
                        >
                            {row.avatarGender}
                        </div>
                    );
                    return (
                        <div className="container-fluid" style={{ textAlign: "left" }}>
                            {element}
                        </div>
                    );
                },
            },
            {
                name: <b style={{ fontSize: "16px" }}>Account ID</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('accountId'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleAccountIdChange(e, row);
                            }}
                            id={"accountId" + row.id}
                            name={"accountId" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.accountId}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Scene ID</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('sceneId'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                            }}
                            onInput={(e) => {
                                this.handleSceneIdChange(e, row);
                            }}
                            id={"sceneId" + row.id}
                            name={"sceneId" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.sceneId}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Version ID</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('versionId'),
                selector: (row) => (
                    <div>
                        <div
                            className="textarea"
                            style={{
                                background: "white",
                                height: "2.7em",
                                resize: "none",
                                paddingLeft: "2px",
                                paddingTop: "6px",
                                width: "100%",
                                border:
                                    row.id == "" || row.id == this.state.editedId
                                        ? "1px solid #D2D4DC"
                                        : "none",
                                borderRadius: row.id == "" ? "2px" : "none",
                                overflowY: "scroll",
                            }}
                            onInput={(e) => {
                                this.handleVersionIdChange(e, row);
                            }}
                            id={"versionId" + row.id}
                            name={"versionId" + row.id}
                            contentEditable={
                                !(row.id == "" ? false : row.id != this.state.editedId)
                                    ? "plaintext-only"
                                    : false
                            }
                        >
                            {row.versionId}
                        </div>
                    </div>
                ),
            },
            {
                name: <b style={{ fontSize: "16px" }}>Actions</b>,
                width: 100,
                selector: (row) => (
                    <div id="action">
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginLeft: '-6px'
                            }} >
                            <img className="img-responsive"
                                title={row.id == "" || (row.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px',
                                    padding: '1px',
                                    width: '100%',
                                    fontSize: '15px'
                                }}
                                src={row.id == "" ? this.saveImageSrc : ((row.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    this.state.dataStartedProcessing
                                        ? this.notifyDataProcessing() :
                                        row.id == "" ? this.saveAvatarDetails(row, e) : (row.id == this.state.editedId) ?
                                            this.updateAvatarDetails(row, e) : this.makeCelledit(row, e);
                                }} />
                        </button>
                        <button
                            style={{
                                backgroundColor: "#ffffff",
                                border: "none",
                                marginTop: '-9px',
                                marginLeft: '-6px'
                            }}
                            title="Delete">
                            <img className="img-responsive"
                                src={"./assets/images/baseline_delete_white_24dp.png"}
                                title="Delete"
                                style={{
                                    marginTop: '6px',
                                    backgroundColor: '#282a65',
                                    borderRadius: '5px',
                                    padding: '1px'
                                }}
                                onClick={() => (row.id) === '' ?
                                    this.fetchAvatarDetails() :
                                    this.openDeletePopUp(row)} />
                        </button >
                    </div>
                ),
            },
        ];
        return (
            <div style={{ background: "#F9F9FB", marginRight: "1%" }}>
                {/* for toaster */}
                <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                {/* for reactTable */}
                <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />


                {/*for dialog component */}
                <link href="assets/css/ej2-base.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                <link href="assets/css/screenResolution.css" rel="stylesheet" />
                {/* Font Awesome Icons */}
                <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                {/* IonIcons */}
                <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                {/* Select2 */}
                <link rel="stylesheet" href="plugins/select2/select2.min.css" />
                <link rel="stylesheet" href="assets/css/toggleButton.css" />
                <link rel="stylesheet" href="./assets/css/styles.css" />
                <div className="row" style={{ marginLeft: "15px" }}>
                    <div className="col-sm-4" style={{ marginTop: '2px' }} >

                    </div>
                </div>

                <div className="row" style={{ marginLeft: '14px' }}>
                    <div className="col-sm-5">
                        <h6 className="nav-item" style={{ color: '#282a65', marginTop: '15px' }}>
                            Avatar </h6>
                    </div>
                    <div className="col-sm-5" Align="right">
                        <input
                            type="text"
                            style={{
                                width: "10vw",
                                border: "1px solid #777676",
                                borderRadius: "3px",
                                padding: "10px",
                                height: "0.6vw",
                                paddingRight: "2rem",
                            }}
                            value={this.state.searchTerm}
                            onChange={this.handleSearch}
                            placeholder="Search ..."
                        />
                        {this.state.searchTerm && (
                            <span
                                onClick={() => this.clearSearchData()}
                                style={{
                                    // position: "absolute",
                                    right: "8px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                    color: "#777676",
                                    fontSize: "1.2rem",
                                    fontWeight: "bold",
                                    lineHeight: 1,
                                    userSelect: "none",
                                    marginLeft: "-1vw"
                                }}
                            >
                                ×
                            </span>
                        )}
                    </div>
                    <div 
                    // className="col-sm-2 " 
                    id='addrefresh-btn' style={{ marginTop: '-18px', marginLeft: "4vw" }}>
                        <div className="d-flex flex-row-reverse pt-2" style={{ marginTop: '-1vh' }}>

                            <div className="p-2" style={{ marginBottom: '10px' }}>

                                <button className="btn action-button"
                                    id="addMsg" title=" Add "
                                    onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addNewAvatarRow}>
                                    <img src="assets/images/add_white_24dp.png" />
                                </button>
                                <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" style={{ marginLeft: '15px', marginTop: '-15px' }}>
                    <div className="col-lg-12 ">
                        {!this.state.noMatchingData &&
                            <div className="card">
                                {this.state.isLoading && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>Loading ...</p>
                                    </div>
                                )}
                                {!this.state.isLoading && this.state.data.length === 0 && (
                                    <div style={{ padding: '20px', textAlign: 'center' }}>
                                        <p>There are no avatar present.</p>
                                    </div>
                                )}
                                {(!this.state.isLoading && this.state.data.length > 0) && (

                                    <DataTable
                                        data={this.state.data}
                                        columns={columns}
                                        defaultPageSize={10}
                                        pageSizeOptions={[5, 10, 15]}
                                        pagination={this.state.paginationValue}
                                        onPageChange={this.onPageChange}
                                        page={this.state.pageNum}
                                        noDataComponent={<this.CustomNoDataComponent />}
                                    />
                                )}
                            </div>
                        }
                        <ToastContainer className="Toast-at-center" />
                    </div>
                </div>
                <div className='card'>
                    {this.state.noMatchingData &&
                        <div style={{ padding: '20px', textAlign: 'center', boxShadow: "0 0 10px rgba(0, 0, 0, 0.2)" }}>
                            <p>No matching options found ...</p>
                        </div>
                    }
                </div>
            </div>
        )
    }
}

export default Avatar;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/Avatar.js